<template>
    <div>
        <h6>CAMPO DE INTERAÇÃO</h6>

        <app-color-picker v-model="color"
                          :data-control-name="$t('message.campaigns.message.font')"
                          type="FONT"
                          :interaction="dataInteraction"
                          :eyedropper="true"
                          :data-show-checkbox="false"></app-color-picker>

        <app-color-picker v-model="backgroundColor"
                          :data-control-name="$t('message.campaigns.message.background')"
                          type="BACKGROUND"
                          :data-active="dataInteraction.estilo && dataInteraction.estilo.openField.background.color && dataInteraction.estilo.openField.background.active"
                          :interaction="dataInteraction"
                          :eyedropper="true"
                          @checkbox="(evt) => checkbox({value: evt})"></app-color-picker>
    </div>
</template>
<script>
import AppColorPicker from '../../ColorPicker'
import editor from '../../../mixins/editor'
import _ from 'lodash'
import EventBus from '@packages/event-bus'

export default {
    components: {
        AppColorPicker,
    },

    data() {
        return {

        }
    },

    props: {
        dataInteraction: {
            type: Object,
            required: true
        },

        dataOption: {
            type: Object,
            required: false
        },

        dataMaxLength: {
            type: Number
        }
    },

    computed: {
        style() {
            return this.dataInteraction.estilo
        },

        color: {
            get() {
                return this.style.openField.textColor
            },

            set(val) {
                const style = _.cloneDeep(this.style)
                style.openField.textColor = val

                const data = {
                    estilo: style
                }

                this.$store.commit('SET_INTERACTION_DATA', {
                    interactionId: this.dataInteraction.id,
                    data
                })

                this.setTimeout({
                    interaction: this.dataInteraction,
                    data
                })
            }
        },

        backgroundColor: {
            get() {
                return this.style.openField.background.color
            },

            set(val) {
                const style = _.cloneDeep(this.style)
                style.openField.background.color = val

                const data = {
                    estilo: style
                }

                this.$store.commit('SET_INTERACTION_DATA', {
                    interactionId: this.dataInteraction.id,
                    data
                })

                this.setTimeout({
                    interaction: this.dataInteraction,
                    data
                })
            }
        },
    },

    methods: {
        isValidCheckboxSelection(value) {
            const isBackgroundActive = this.dataInteraction.estilo.openField.background.active;

            if(!value && !isBackgroundActive ) {
                EventBus.$emit('show-message', {
                    type: 'ERROR',
                    message: this.$t('message.errorMessages.message.borderOrBackgroundActive')
                })

                return false;
            }

            return true;

        },

        validateAlphaSelection() {},

        checkbox({value }) {
            const isValid = this.isValidCheckboxSelection(value);

            if(isValid) {
                const item = this.dataInteraction

                item.estilo.openField.background.active = value

                const payload = {
                    optionId: null,
                    interactionId: this.dataInteraction.id,
                    advertisingId: this.dataInteraction.campanhaId,
                    data: {
                        estilo: item.estilo
                    }
                }
                this.$api.interactions.update(payload)
            }
        },
    },

    mixins: [editor]
}
</script>
<style lang="scss" scoped>
</style>
